<p>Add the details of an instruction to pass on to your next of kin in the event of your death.</p>
<hr />
<app-master-form [object]="object" [key]="key" [extraData]="extraData"></app-master-form >
